import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Grid } from '@material-ui/core';
import {
  Assessment as ResultsIcon,
  List as TestsIcon,
  Create as CreateIcon,
  Storage as MigrationIcon,
  Person as PersonIcon,
  Description as DescriptionIcon,
  PlayArrow as PlaygroundIcon,
  Stars as AITestIcon
} from '@material-ui/icons';
import TopMenu from '../TopMenu';
import AdminFeatureCard from './AdminFeatureCard';

// Main AdminDashboard component. Feature cards are modularized in AdminFeatureCard.js
const AdminDashboard = () => {
  const history = useHistory();

  const adminFeatures = [
    {
      title: 'Create Assessment Template',
      description: 'Design and configure assessments with multiple question types and sections for recruitment or evaluation.',
      icon: <CreateIcon />, 
      path: '/dynamic-exam-creator',
      color: '#2196f3'
    },
    {
      title: 'Assessment Lookup',
      description: 'Search by assessment code to review details and candidate submissions.',
      icon: <TestsIcon />, 
      path: '/exam-code-entry',
      color: '#607d8b'
    },
    {
      title: 'Results & Analytics',
      description: 'Access assessment results, analytics, and candidate performance data.',
      icon: <ResultsIcon />, 
      path: '/results',
      color: '#e91e63'
    },
    {
      title: 'Candidate Analysis',
      description: 'Analyze candidate performance across multiple assessments for role-specific evaluation.',
      icon: <PersonIcon />, 
      path: '/candidate-analysis',
      color: '#4caf50'
    },
    {
      title: 'JD-Based Candidate Analysis',
      description: 'Dynamic candidate analysis based on Job Description. Upload JD, map questions to JD competencies, and get suitability assessment.',
      icon: <DescriptionIcon />, 
      path: '/new-candidate-analysis',
      color: '#9c27b0'
    },
    {
      title: 'AI Evaluation Playground',
      description: 'Test and refine AI evaluation prompts by comparing original results with custom prompts. View extracted text, scores, and feedback side-by-side.',
      icon: <PlaygroundIcon />, 
      path: '/playground',
      color: '#00bcd4'
    },
    {
      title: 'Migration Tool',
      description: 'Convert old base64 images to Firebase Storage for cost optimization.',
      icon: <MigrationIcon />, 
      path: '/migration-tool',
      color: '#ff9800'
    },
    {
      title: 'AI Test Generator',
      description: 'Generate comprehensive question papers using AI based on Job Description, role requirements, and assessment criteria.',
      icon: <AITestIcon />, 
      path: '/ai-test-generator',
      color: '#9c27b0'
    }
  ];

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto' }}>
      <TopMenu showHome showLogout />
      <Typography variant="h5" gutterBottom mb={3} style={{marginTop: 80}}>
        Administrative Actions
      </Typography>
      <Grid container spacing={3}>
        {adminFeatures.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <AdminFeatureCard
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              color={feature.color}
              onClick={() => history.push(feature.path)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default AdminDashboard; 